import {FC, ReactElement, useEffect, useState} from 'react';
import BigNumber from 'bignumber.js';
import styled from 'styled-components';
import {AppState} from '@/state';
import home_tips_bg from '../../assets/images/home_tips_bg.png'
import home_input_bg from '../../assets/images/home_input_bg.png'
import dayjs from 'dayjs'
import ModalBottom from "components/ModalBottom";
import {getScatter} from "utils/client";
import Server from "utils/serviceApi";
import {
    countryStaticDataEN, countryStaticDataHK, countryStaticDataKR, countryStaticDataRU,
    idTypeData
} from "utils/countryData";
import {makeUUID, sleep} from "utils/met";
import useInterval from "hooks/useInterval";
import Message from "components/toasts/toasts";
import LoadingModal from "components/LoadingModal";
import TipsModal from "components/TipsModal";
import FailModal from "components/FailModal";
import {useTranslation} from "react-i18next";
import FailMessageModal from "components/FailMessageModal";
import {useHistory, useLocation} from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";
import CertificationTipsModal from "components/CertificationTipsModal";
import {md5UUID} from "utils/ase";
import {getUserInfo} from "state/base/reducer";
import {EOSErrorCode} from "utils/eosErrorCode";

const Certification: FC = (): ReactElement => {
    const {t, i18n} = useTranslation();
    const history = useHistory()
    const dispatch = useDispatch();
    const {account} = useSelector((state: AppState) => state.baseInfo)
    const routerState: any = useLocation()
    const {initInfo} = routerState.state || {}
    const {
        getTableRowsByOrders,
        getOrderErrorMsgData,
        transferFee,
        getTableRowsByNFT,
        getTableRowsByVendorinfo,
        getRealIdInitialize,
        getUserBalance,
        getCheckData
    } = Server
    const [modalCountryVisible, setModalCountryVisible] = useState<boolean>(false)
    const [countryName, setCountryName] = useState('')
    const [modalIdTypeVisible, setModalIdTypeVisible] = useState<boolean>(false)
    const [showBalanceVal, setShowBalanceVal] = useState<boolean>(false)
    const [idTypeName, setIdTypeName] = useState('')
    const [idTypeVal, setIdTypeVal] = useState('')
    const [idTypeLst, setIdTypeLst] = useState<any[]>([])
    const [countryLst, setCountryLst] = useState<any[]>([])
    const [messageVal, setMessageVal] = useState('')
    const [loadingVal, setLoadingVal] = useState('')
    const [tipsVisible, setTipsVisible] = useState<boolean>(false)
    const [certificationtipsVisible, setCertificationTipsVisible] = useState<boolean>(false)
    const [failedVisible, setFailedVisible] = useState<boolean>(false)
    const [failedMessageVisible, setFailedMessageVisible] = useState<boolean>(false)
    const [failedMsg, setFailedMsg] = useState('')
    const [initializeParams, setInitializeParams] = useState(null)
    const [intervalInitPost, setIntervalInitPost] = useState<boolean>(false)
    const [delay, setDelay] = useState<number>(3000)
    useInterval(async () => {
        if (intervalInitPost) {
            const initData = await getRealIdInitialize(initializeParams)
            if (initData.code === 9003) {
                setIntervalInitPost(false)
                history.push('/success')
            } else if (initData.code === 9005) {
                setLoadingVal('')
                setIntervalInitPost(false)
                setFailedMsg(t('home.signatureFailed'))
                setFailedMessageVisible(true)
            } else if (initData && initData.data) {
                setLoadingVal('')
                setIntervalInitPost(false)
                const baseurl = 'https://sg-production-cdn.zoloz.com/page/zoloz-realid-fe/index.html'
                const zolozurl = baseurl + "?clientcfg=" + encodeURIComponent(initData.data.clientCfg);
                window.location.href = zolozurl;
            } else {
                setDelay(new BigNumber(delay).times(2).toNumber())
            }
        }
    }, delay)
    useEffect(() => {

        const getErrorMsg = async () => {
            const errorMsgData = await getOrderErrorMsgData({userId: account.name})
            if (errorMsgData.code === 200 && errorMsgData.data) {
                if (errorMsgData.data.errorMsgCode === 'IdNumberDuplicate') {
                    const amountVal = String(Number(initInfo.charge_amount_val ? initInfo.charge_amount_val : 0.02) + ' ' + String(initInfo.amount_unit ? initInfo.amount_unit : 'AMAX'))
                    setFailedMsg(t('home.IdNumberDuplicate', {amount: amountVal}))
                    setFailedMessageVisible(true)
                } else if (errorMsgData.data.errorMsgCode === 'VoidTimeout') {
                    setFailedMsg(t('home.timeout'))
                    setFailedMessageVisible(true)
                }
            }

        }
        if (account.name) {
            void getErrorMsg()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [account.name, getOrderErrorMsgData, setFailedMsg, setFailedMessageVisible, getTableRowsByVendorinfo, initInfo.charge_amount_val])


    useEffect(() => {
        const initData = async () => {
            if (account.name) {
                try {
                    const musdtVal = await getUserBalance(account.name, 'amax')

                    if (Number(musdtVal) < Number(initInfo.charge_amount_val)) {
                        setShowBalanceVal(true)

                    } else {
                        setShowBalanceVal(false)
                    }

                } catch (e) {
                    console.log(e)
                }

            }
        }
        if (!initInfo.hasPay) {
            void initData()
        }


    }, [account.name, getTableRowsByVendorinfo, getTableRowsByNFT, getUserBalance, getCheckData, getTableRowsByOrders, getOrderErrorMsgData, setFailedMsg, setFailedMessageVisible, initInfo.charge_amount_val,initInfo.hasPay])

    const handleSubmit = async () => {
      // debugger
        if (showBalanceVal) {
            setMessageVal(t('home.Insufficient'))
            await sleep(2000)
            setMessageVal('')
            return
        }
        if (!countryName) {
            setMessageVal(t('home.selectCountry'))
            await sleep(2000)
            setMessageVal('')
            return
        }
        if (!idTypeVal) {
            setMessageVal(t('home.selectIDType'))
            await sleep(2000)
            setMessageVal('')
            return
        }

        try {
            setLoadingVal(t('home.Waiting'))
            const ordersData = await getTableRowsByOrders(account.name)
            const uuid = makeUUID()
            const currentTsVal = dayjs().unix();
            const md5 = md5UUID(uuid + currentTsVal)
            const scatter: any = getScatter()
            let signData = ''

            if (ordersData.rows.length === 0) {
                await transferFee(account.name, initInfo.user_charge_quant, `${initInfo.vendor_account}:${initInfo.kyc_level}:${md5}`)
                const signatureString = account.name + ':' + idTypeVal + ':' + currentTsVal;
                signData = await scatter.getArbitrarySignature(
                    account.publicKey,
                    signatureString,
                );
            } else {
                const signatureString = account.name + ':' + idTypeVal + ':' + currentTsVal;
                console.log(account.publicKey,signatureString);
                signData = await scatter.getArbitrarySignature(
                    account.publicKey,
                    signatureString,
                );
            }

            setInitializeParams({
                parms: {
                    userId: account.name,
                    docType: idTypeVal,
                    currentTs: currentTsVal,
                  }, signData: signData,checkerType:'realme'
            })
            setIntervalInitPost(true)

        } catch (e) {
            setLoadingVal('')
            const _errorResult = typeof e === 'string' ? JSON.parse(e) : e;
            if(_errorResult.error && _errorResult.error.code){
                const eosMsg = EOSErrorCode.getEOSErrorMessage(String(_errorResult.error.code), i18n.language)
                setFailedMsg(eosMsg)
                setFailedMessageVisible(true)
            }else{
                setFailedVisible(true)
            }

            console.log(e)
        }


    }
    const handleShowCountry = () => {
        if (i18n.language === 'en_US') {
            setCountryLst(countryStaticDataEN)
        } else if (i18n.language === 'zh_HK') {
            setCountryLst(countryStaticDataHK)
        } else if (i18n.language === 'ko_KR') {
            setCountryLst(countryStaticDataKR)
        } else if (i18n.language === 'ru') {
            setCountryLst(countryStaticDataRU)
        }

        setModalCountryVisible(true)
    }
    const handleModalCountry = (name: string, val: string) => {
        setCountryName(name)
        const arrayData = idTypeData[i18n.language][val]
        setModalCountryVisible(false)
        if (arrayData && arrayData.length > 0) {
            setIdTypeLst(arrayData)
            setIdTypeVal('')
            setIdTypeName('')
            setModalIdTypeVisible(true)
        } else {
            setIdTypeLst(idTypeData[i18n.language]['Other'])
            setIdTypeVal(idTypeData[i18n.language]['Other'][0].value)
            setIdTypeName(idTypeData[i18n.language]['Other'][0].name)
        }

    }
    const handleModalIdType = (name: string, val: string) => {
        setIdTypeVal(val)
        setIdTypeName(name)
        setModalIdTypeVisible(false)
    }
    const connectWallt = () => {
        dispatch(getUserInfo());
    }
    return (
        <Main>
            <CertificationContent>
                <BgElementImg src={require('img/home_bg_element_img.png').default} alt=""/>
                <InputContent>
                    {t('home.Country')}
                    <InputData style={{marginBottom: '0.2rem'}} onClick={() => handleShowCountry()}>
                        <p>{countryName}</p>
                        <ListArrowIcon src={require('img/list_arrow_icon.png').default} alt=""/>
                    </InputData>
                    {t('home.IDType')}
                    <InputData onClick={() => setModalIdTypeVisible(true)}>
                        <p>{idTypeName}</p>
                        <ListArrowIcon src={require('img/list_arrow_icon.png').default} alt=""/>
                    </InputData>
                    {initInfo.hasPay ? <PromptContentLeft><span>{t('home.Paid')}</span></PromptContentLeft> :
                        <PromptContent><span>{t('home.YouNeed')}{Number(initInfo.charge_amount_val) > 0 ? Number(initInfo.charge_amount_val) : '?'} {initInfo.amount_unit}</span></PromptContent>}

                    {account.name ? <CertificationBtn onClick={handleSubmit}>
                        <div>{showBalanceVal ? t('home.Insufficient') : `DID ${t('home.Certification')}`}</div>
                    </CertificationBtn> : <CertificationBtn onClick={connectWallt}>
                        <div>{t('layout.connect')}</div>
                    </CertificationBtn>}

                </InputContent>
                <a href='https://m.amaxswap.xyz/'>
                    {t('home.GetAMAX')}
                </a>
                <ConnectTip>
                    <ContentHeader>
                        <img src={require('img/tipa_did_icon.png').default} alt=""/>
                        <div>
                            <p><em>DID</em><span className='detail'>{t('home.decentralized')}</span></p>
                            <p style={{marginTop: '0.06rem'}}>{t('home.IDBlock')}</p>
                        </div>
                    </ContentHeader>
                    <div className='content-data'>
                        <p>{t('home.getA')} <span>DID-NFT</span>{t('home.getOther')}<span>DID-NFT</span></p>
                        <div className='tips-txt' onClick={() => setCertificationTipsVisible(true)}>
                            <p>{t('home.toPassVerification')}
                                <span>{t('home.ViewExample')}</span>
                                <img src={require('img/icon_tip.png').default} alt=""/>
                            </p>

                        </div>
                    </div>
                    <div className='tip-txt' onClick={() => setTipsVisible(true)}>
                        <TipsImg src={require('img/tips_icon.svg').default} alt=""/>
                        DID-NFT {t('home.transferredOthers')}
                    </div>

                </ConnectTip>

            </CertificationContent>

            {modalCountryVisible &&
            <ModalBottom title={t('home.Country')} onClose={() => setModalCountryVisible(false)}
                         chooseArray={countryLst}
                         onConfirm={(name: string, val: string) => handleModalCountry(name, val)}/>}

            {modalIdTypeVisible &&
            <ModalBottom title={t('home.IDType')} defaultName={idTypeName} defaultVal={idTypeVal}
                         onClose={() => setModalIdTypeVisible(false)}
                         chooseArray={idTypeLst}
                         onConfirm={(name: string, val: string) => handleModalIdType(name, val)}/>}
            {messageVal && <Message content={messageVal}/>}
            {loadingVal && <LoadingModal content={loadingVal}/>}
            {tipsVisible && <TipsModal onClose={() => setTipsVisible(false)}/>}
            {failedVisible && <FailModal onClose={() => setFailedVisible(false)}/>}
            {failedMessageVisible && <FailMessageModal msg={failedMsg} onClose={() => setFailedMessageVisible(false)}/>}
            {certificationtipsVisible && <CertificationTipsModal onClose={() => setCertificationTipsVisible(false)}/>}
        </Main>
    );
};

const Main = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const CertificationContent = styled.div`
  position: relative;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  height: 100%;
  padding: 0.81rem 0.16rem 0 0.16rem;
  a{
    margin-top: 0.12rem;
    font-size: 0.16rem;
    font-weight: 600;
    color: #08BDC7;
  }
`;

const BgElementImg = styled.img.attrs(props => ({
    src: props.src,
    alt: props.alt,
}))`
  height: 136px;
  position: absolute;
  top: 0.4rem;
  right: 0.2rem;
`;

const InputContent = styled.div`
  position: relative;
  width: 100%;
  height: 2.75rem;
  margin-bottom: 0.2rem;
  font-size: 0.16rem;
  font-weight: 500;
  color: #6C6C76;
  text-align: left;
  border-radius: 0.16rem;
  padding: 0.24rem 0.16rem;
  margin-top: 0.2rem;
  box-shadow: 0 0.04rem 0.2rem 0 rgba(32, 95, 201, 0.3);
  background: url(${home_input_bg}) no-repeat center;
  background-size: 100% 100%;
`;

const CertificationBtn = styled.div`
  height: 44px;
  background: linear-gradient(135deg, #49ADFF 0%, #1DEECE 100%);
  box-shadow: 0px 4px 10px 0px rgba(67, 178, 203, 0.2);
  border-radius: 22px;
  text-align: center;
  line-height: 32px;
  font-weight: 600;
  color: #FFFFFF;
  padding: 5px 6px;
  width: 90%;
  position: absolute;
  bottom: -22px;

  div {
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.24) 0%, rgba(255, 255, 255, 0) 100%);
    box-shadow: 0px 4px 10px 0px rgba(67, 178, 203, 0.2);
    border-radius: 22px;
  }
`;


const InputData = styled.div`
  background: rgba(255, 255, 255, 0.9);
  width: 100%;
  border-radius: 0.22rem;
  display: flex;
  margin-top: 0.12rem;
  padding: 0 0.16rem;
  justify-content: space-between;
  align-items: center;
  height: 0.44rem;

  p {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 0.18rem;
    font-weight: 500;
    color: #333333;
  }
`;

const ListArrowIcon = styled.img.attrs(props => ({
    src: props.src,
    alt: props.alt,
}))`
  height: 0.16rem;
`;

const TipsImg = styled.img.attrs(props => ({
    src: props.src,
    alt: props.alt,
}))`
  width: 0.16rem;
  height: 0.16rem;
  margin-right: 0.04rem;
`;

const ContentHeader = styled.header`
  display: flex;
  align-items: center;
  font-size: 0.14rem;
  font-weight: 400;
  color: #161617;
  padding: 0.18rem 0.12rem 0 0.12rem;

  div {
    display: flex;
    flex-direction: column;
  }

  p {
    display: inline-flex;
  }

  .detail {
    font-size: 0.12rem;
    font-weight: 400;
    color: rgba(22, 22, 23, 0.3);
  }

  em {
    font-size: 0.2rem;
    font-weight: 600;
    color: #08BDC7;
  }

  img {
    width: 0.55rem;
    margin-right: 0.16rem;
  }
`;

const ConnectTip = styled.div`
  position: relative;
  width: 100%;
  flex: 1;
  font-size: 0.13rem;
  font-family: PingFang SC-Bold, PingFang SC;
  text-align: left;
  margin-top: 0.12rem;
  background: url(${home_tips_bg}) no-repeat center;
  background-size: 100% 100%;
  color: #58585E;
  line-height: 0.18rem;

  span {
    color: #08BDC7;
  }

  .content-data {
    padding: 0.16rem 0.12rem;

    .tips-txt {
      margin-top: 0.04rem;
      font-size: 0.13rem;
      font-weight: 400;
      color: #FF2828;
      display: flex;
      line-height: 0.18rem;

      img {
        margin-left: 0.04rem;
        width: 0.12rem;
      }
    }
  }

  .tip-txt {
    position: absolute;
    bottom: 0.12rem;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.12rem;
    font-weight: 400;
    color: #A1A1B3;
  }
`;


const PromptContent = styled.div`
  width: 60%;
  position: absolute;
  right: 0;
  margin-top: 0.1rem;
  background: #FFE063;
  border-radius: 0.08rem;
  font-weight: 500;
  text-align: left;
  color: #D98000;
  background-size: 100% 100%;
  height: 0.30rem;
  padding-left: 0.12rem;
  line-height: 0.30rem;
  font-size: 0.12rem;

  span {
    position: absolute;
    left: 0.08rem;
  }

  &:before {
    position: relative;
    display: inline-block;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 8px solid #FFE063;
    top: 0.16rem;
    content: '';
  }
`;
const PromptContentLeft = styled.div`
  width: 60%;
  position: relative;
  left: 0.16rem;
  margin-top: 0.1rem;
  background: #FFE063;
  border-radius: 0.08rem;
  font-weight: 500;
  text-align: left;
  color: #D98000;
  background-size: 100% 100%;
  height: 0.30rem;
  padding-left: 0.12rem;
  line-height: 0.30rem;
  font-size: 0.12rem;

  span {
    position: absolute;
    left: 0.08rem;
  }

  &:before {
    position: relative;
    display: inline-block;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 8px solid #FFE063;
    top: 0.16rem;
    content: '';
  }
`;


export default Certification;
